import React, { useEffect, useState } from "react";
import "./Home.css";

const PUBLIC = process.env.PUBLIC_URL || "";
const API_BASE = process.env.REACT_APP_API_BASE ?? (process.env.NODE_ENV === "production" ? "" : "http://localhost:5000");

export default function Home() {
    const [showModal, setShowModal] = useState(false);
    const [idx, setIdx] = useState(0);
    const [showWelcomePopup, setShowWelcomePopup] = useState(false);
    const [welcomePopup, setWelcomePopup] = useState(null);

    const images = [
        `${PUBLIC}/LogoGIF/Unity_Logo.gif`,
        `${PUBLIC}/LogoGIF/Phi3_Logo.gif`,
        `${PUBLIC}/LogoGIF/SigmaLogo.gif`,
        `${PUBLIC}/LogoGIF/Soal_Logo.gif`,
    ];

    // Load the popup selected by the backend schedule and show it once per session.
    useEffect(() => {
        const updateWelcomePopup = async () => {
            try {
                const response = await fetch(`${API_BASE}/api/auto-popups/active`, { cache: "no-store" });
                const data = await response.json();
                const popup = response.ok && data.ok ? data.row : null;
                setWelcomePopup(popup);
                if (!popup) return setShowWelcomePopup(false);
                const sessionKey = `autoPopupShown-${popup.id}`;
                if (!sessionStorage.getItem(sessionKey)) {
                    setShowWelcomePopup(true);
                    sessionStorage.setItem(sessionKey, "true");
                }
            } catch {
                setWelcomePopup(null);
                setShowWelcomePopup(false);
            }
        };

        updateWelcomePopup();
        const timer = window.setInterval(updateWelcomePopup, 60 * 1000);
        return () => window.clearInterval(timer);
    }, []);

    useEffect(() => {
        const id = setInterval(() => setIdx((i) => (i + 1) % images.length), 5000);
        return () => clearInterval(id);
    }, [images.length]);

    const closeOnOverlay = (e) => {
        if (e.target.classList.contains("modal-overlay")) setShowModal(false);
    };

    return (
        <section
            id="home"
            className="home"
            style={{
                "--home-lightning-bg": `url("${PUBLIC}/larawan/TGPLogoLightning.png")`,
                "--home-mobile-bg": `url("${PUBLIC}/larawan/TGPLogoMobile.png")`,
            }}
        >

            {/* 🔔 WELCOME POPUP */}
            {showWelcomePopup && welcomePopup && (
                <div className="welcome-overlay" onClick={() => setShowWelcomePopup(false)}>
                    <div className="welcome-modal large" onClick={(e) => e.stopPropagation()}>
                        <button
                            className="welcome-close top"
                            onClick={() => setShowWelcomePopup(false)}
                            aria-label="Close"
                        >
                            ✕
                        </button>

                        <div className="welcome-message">
                            <h2>{welcomePopup.title}</h2>
                            {welcomePopup.message && <p>{welcomePopup.message}</p>}
                        </div>

                        {welcomePopup.media_type === "video" ? <video className="welcome-media" src={welcomePopup.media_path.startsWith("/videos/") ? `${PUBLIC}${welcomePopup.media_path}` : `${API_BASE}${welcomePopup.media_path}`} autoPlay muted controls /> : <img className="welcome-media" src={welcomePopup.media_path.startsWith("/videos/") ? `${PUBLIC}${welcomePopup.media_path}` : `${API_BASE}${welcomePopup.media_path}`} alt={welcomePopup.title} />}

                    </div>
                </div>
            )}


            {/* ===== HOME CONTENT ===== */}
            <div className="home-content">
                <h1>
                    <span className="home-title-line home-title-line-main">
                        Welcome to the Southern Alberta Canada
                    </span>
                    <span className="home-title-line">
                        Triskelions' Grand Fraternity and Sorority
                    </span>
                </h1>

                <p>
                    Our fraternity and sorority is a group of individuals who share a common goal
                </p>

                <div className="slideshow-container">
                    {images.map((src, i) => (
                        <img
                            key={src}
                            src={src}
                            alt={`Slide ${i + 1}`}
                            className={`slide2 ${i === idx ? "active" : ""}`}
                            onError={(e) => e.currentTarget.remove()}
                        />
                    ))}
                </div>

                <button className="btn-primary btn-SeeMore" onClick={() => setShowModal(true)}>
                    See More
                </button>
            </div>

            {showModal && (
                <div className="modal-overlay" onClick={closeOnOverlay}>
                    <div className="modal-box-home" onClick={(e) => e.stopPropagation()}>
                        <button className="close-button" onClick={() => setShowModal(false)} aria-label="Close">✖</button>

                        <div className="modal-title">
                            <h2>Triskelion Brotherhood Stories</h2>
                        </div>

                        <div className="modal-two-columns">
                            <div className="column">
                                <figure className="logo-tile">
                                    <img className="brotherhood-story-logo" src={`${PUBLIC}/images/Tgphi-png.png`} alt="Tau Gamma Phi" />
                                    <figcaption>Phi Legacy</figcaption>
                                    <p>
                                        Tau Gamma Phi, also known as the Triskelions’ Grand Fraternity, is a fraternity founded at the University of the Philippines Diliman on October 4, 1968. Recognized as one of the largest fraternities in the Philippines, Tau Gamma Phi is also regarded as a protest fraternity, committed to the dual mission of promoting a fraternity system free from violence and propagating the Triskelion principles as a way of life.                                    </p>
                                    <p>
                                        In 1968, six concerned student leaders came together with a shared vision of reforming the fraternity system, which at the time was perceived as feudal and outdated. This initiative led to the establishment of Tau Gamma Phi. Over time, four members were officially recognized as the founding fathers: Rodolfo “Sta. Maria” Confessor, Roy “Alolor” Ordinario, Talek “Hamias” Pablo, and Vedasto “Tito” Sario Venida.                                    </p>
                                    <p>
                                        Over the years, Tau Gamma Phi has remained steadfast in its goals despite various challenges and adversities. It has grown significantly, guided by the belief that strength fosters peace—not weakness. The fraternity continues to advocate against violence and remains committed to its founding principles.                                    </p>
                                    <p>
                                        Furthermore, Tau Gamma Phi has fostered inter-fraternity collaboration across the country, aiming to build a culture of fellowship, mutual respect, and shared growth among fraternities. Today, it stands as one of the most widespread fraternities in the Philippines, with an extensive network of members and community-based chapters, including the Triskelion Youth Movement (TYM). It has established numerous chapters nationwide, along with alumni organizations around the world.                                    </p>
                                    <p>
                                        Tau Gamma Phi’s vision and mission are centered on serving and excelling in all fields of human endeavor, guided by the Triskelion Tenets and Code of Conduct. It upholds the principle that “Man is brother unto man,” emphasizing unity, brotherhood, and mutual support. All Triskelions share a common bond and strive to support one another in achieving their goals and realizing their aspirations.                                    </p>
                                </figure>
                            </div>

                            <div className="column">
                                <figure className="logo-tile">
                                    <img className="brotherhood-story-logo" src={`${PUBLIC}/images/Sigma-PNG.png`} alt="Tau Gamma Sigma" />
                                    <figcaption>Sigma Spirit</figcaption>
                                    <p>
                                        Tau Gamma Sigma, also known as The Triskelions’ Grand Sorority, was founded on January 17, 1969 at the University of the Philippines, Diliman. Established by ten pioneering women, it became the sister organization of Tau Gamma Phi. From its beginnings, the sorority has stood as a beacon of courage, unity, and empowerment for women in the academic, civic, and social spheres. Despite challenges, including the effects of martial law in the 1970s, Tau Gamma Sigma has remained steadfast in carrying forward its ideals and nurturing generations of Lady Triskelions.
                                    </p>
                                    <p>
                                        Over the decades, the sorority has expanded its influence beyond campus walls, engaging in community service, charitable activities, and cultural programs. Its members are known not only for their loyalty to the Triskelion name but also for their dedication to society. With every outreach, fellowship, and act of service, Tau Gamma Sigma has proven that it is more than an organization—it is a movement built on discipline, compassion, and unity.
                                    </p>
                                    <p>
                                        The sorority’s strength lies in its pillars: Fortis, Voluntas, and Sororitas—Strength, Free Will, and Sisterhood. These values are the guiding light of every Lady Triskelion, reminding them to lead with courage, act with integrity, and support one another. It is through these enduring principles that Tau Gamma Sigma continues to inspire women to embrace leadership and contribute meaningfully to both their communities and their nation.
                                    </p>
                                    <p>
                                        The Vision of Tau Gamma Sigma is to build a community of empowered women united in sisterhood, guided by strength and free will, and dedicated to service. Its Mission is to nurture Lady Triskelions who exemplify integrity, discipline, and leadership—women who will uphold the tenets of the sorority, promote academic excellence, serve their communities, and strengthen the bonds of family, brotherhood, and sisterhood.
                                    </p>
                                </figure>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
}
